class GiftWrappingComponent extends HTMLElement {
  constructor() {
    super();

    this.cartDrawer = document.querySelector("m-cart-drawer");
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.itemsInCart = parseInt(this.getAttribute("items-in-cart"));
    this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
    this.cart = document.querySelector("m-cart-drawer");

    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      event.target.checked ? this.setGiftWrapping() : this.removeGiftWrapping();
    });

    if (this.cartDrawer) return;

    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrapping();
    } else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.itemsInCart) {
      this.setGiftWrapping();
    } else if (this.giftWrapsInCart > 0 && this.giftWrapping === "false") {
      this.setGiftWrapping();
    } else if (this.giftWrapsInCart == 0 && this.giftWrapping === "true") {
      this.setGiftWrapping();
    }
  }

  setGiftWrapping() {
    this.loadingIcon.classList.add("show");

    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: this.itemsInCart,
        },
        attributes: { "gift-wrapping": true },
      }),
    };

    this.updateCart(request);
  }

  removeGiftWrapping() {
    this.loadingIcon.classList.add("show");

    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: 0,
        },
        attributes: { "gift-wrapping": false },
      }),
    };

    this.updateCart(request);
  }

  updateCart(request) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, request)
      .then((response) => response.json())
      .then((response) => {
        this.loadingIcon.classList.remove("show");

        if (document.body.classList.contains("template-cart")) {
          window.location.href = MinimogSettings.routes.cart;
          return;
        }

        if (this.cartDrawer) {
          this.cart.onCartDrawerUpdate();
          this.cartDrawer.classList.toggle("m-cart--empty", response.item_count === 0);
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, response);
        }

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: response },
          })
        );
      })
      .catch((e) => console.error(e));
  }
}

customElements.define("m-gift-wrapping-component", GiftWrappingComponent);



/* =========================
   GIFT NOTE → SAVES TO ORDER NOTE
========================= */

class GiftNoteComponent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "input",
      debounce((event) => {
        const request = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            note: event.target.value // ✅ Saves to Shopify native Order Note
          }),
        };

        fetch(`${MinimogSettings.routes.cart_update_url}`, request)
          .then((res) => res.json())
          .catch((err) => console.error(err));
      }, 300)
    );
  }
}

customElements.define("m-gift-note-component", GiftNoteComponent);



/* =========================
   GIFT WRAPPING QUANTITY
========================= */

class GiftWrappingQuantityInput extends MQuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrapping = document.querySelector("m-gift-wrapping-component");
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.itemsInCart = parseInt(this.getAttribute("items-in-cart"));

    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.giftWrapping.removeGiftWrapping();
    } else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.itemsInCart) {
      this.update();
    } else if (this.giftWrapsInCart > 0 && !this.giftWrapping) {
      this.update();
    } else if (this.giftWrapsInCart == 0 && this.giftWrapping) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("m-gift-wrapping-input", GiftWrappingQuantityInput);